import type { Legal, NavLinkColumn } from './types'

export const legal_br: Legal[] = [
  {
    key: 'privacy_notice',
    name: 'Privacy Notice',
    href: '/privacy/brazil',
  },
  {
    key: 'status',
    name: 'Status',
    href: 'https://status.crypto.com',
  },
]

export const desktop_br: NavLinkColumn[] = [
  [
    {
      tTitle: 'products.app',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.buyAndSell',
          href: '/br/app',
        },
        {
          tTitle: 'products.earn',
          href: '/br/earn',
        },
        {
          tTitle: 'products.pay',
          href: '/br/pay',
        },
      ],
    },
    {
      tTitle: 'products.cards',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.metalCards',
          href: '/br/cards',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.exchange',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.exchangeIndex',
          href: 'https://crypto.com/exchange',
        },
        {
          tTitle: 'products.syndicate',
          href: 'https://crypto.com/exchange/syndicate',
        },
        {
          tTitle: 'products.supercharger',
          href: 'https://crypto.com/exchange/supercharger',
        },
        {
          tTitle: 'products.tradingArena',
          href: 'https://crypto.com/exchange/trading-arena',
        },
      ],
    },
    {
      tTitle: 'products.commerce',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.payMerchant',
          href: '/br/pay-merchant',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.defi',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.wallet',
          href: '/br/defi-wallet',
        },
        {
          tTitle: 'products.swap',
          href: 'https://crypto.com/defi/swap',
        },
        {
          tTitle: 'products.defiEarn',
          href: '/br/defi-wallet#earn',
        },
        {
          tTitle: 'products.dashboard',
          href: 'https://crypto.com/defi/dashboard/gas-fees',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.resources',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.prices',
          href: 'https://crypto.com/price',
        },
        {
          tTitle: 'products.siteWidgets',
          href: 'https://crypto.com/price/widget',
        },
        {
          tTitle: 'company.support',
          href: 'https://help.crypto.com/en',
        },
        {
          tTitle: 'products.por',
          href: '/br/proof-of-reserves',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'navbar.learn',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'learn.trending',
          href: '/trending',
        },
        {
          tTitle: 'learn.productNews',
          href: '/product-news',
        },
        {
          tTitle: 'learn.events',
          href: '/events',
        },
        {
          tTitle: 'learn.university',
          href: '/university',
        },
        {
          tTitle: 'learn.research',
          href: '/research',
        },
        {
          tTitle: 'learn.marketUpdates',
          href: '/market-updates',
        },
        {
          tTitle: 'learn.nftStories',
          href: '/nft-stories',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'navbar.company',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'company.about',
          href: '/br/about',
        },
        {
          tTitle: 'company.careers',
          href: '/br/careers',
        },
        {
          tTitle: 'company.news',
          href: 'https://crypto.com/company-news',
        },
        {
          tTitle: 'company.security',
          href: '/br/security',
        },
        {
          tTitle: 'company.contact',
          href: '/br/about#page-contact',
        },
        {
          tTitle: 'company.capital',
          href: '/br/capital',
        },
        {
          tTitle: 'company.climate',
          href: 'https://crypto.com/company-news/crypto-coms-climate-commitment-2',
        },
        {
          tTitle: 'company.affiliate',
          href: '/br/affiliate',
        },
        {
          tTitle: 'company.partners',
          href: '/br/partners',
        },
        {
          tTitle: 'navbar.nft',
          href: 'https://crypto.com/nft',
          tBadgeTitle: 'navbar.new',
        },
      ],
    },
  ],
]

export const mobile_br = desktop_br.flatMap((menu) => menu)
